import { render } from "./OrdersRow.vue?vue&type=template&id=6a8317cc&scoped=true"
import script from "./OrdersRow.vue?vue&type=script&lang=js"
export * from "./OrdersRow.vue?vue&type=script&lang=js"

import "./OrdersRow.vue?vue&type=style&index=0&id=6a8317cc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8317cc"]])

export default __exports__